export default "__VITE_ASSET__BLXLOdew__"